import { PlusOutlined } from "@ant-design/icons";
import { authApi } from "@api";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
} from "@components";

import { PATH_ADD_ADMIN, adminFilter, enumFilter, initPage } from "@configs";
import { IAdmin, IPagination } from "@interfaces";
import { AdminTable } from "@modules";
import { selectApp, setLoading } from "@redux";
import { useNotify } from "@utils";
import { Tooltip } from "antd";
import { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

export const PageListAdmin = () => {
  // hook
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error } = useNotify();
  const { mobile } = useSelector(selectApp);
  // state
  const [page, setPage] = useState<IPagination>(initPage);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState<IAdmin[]>([]);
  const [filters, setFilters] = useState<enumFilter | string>("");
  const [text, setText] = useState<string>("");
  const [date, setDate] = useState<string[]>([]);

  useEffect(() => {
    fetchAdmin();
  }, [page, text, date]);

  const fetchAdmin = async () => {
    try {
      dispatch(setLoading(true));
      const res = await authApi.admins({
        page: page.page,
        limit: page.limit,
        searchColumn: filters,
        search: text,
        startDate: date[0],
        endDate: date[1],
      });
      setData(res.data?.data);
      setTotal(res.data?.nTotal);
      success(t("message.fetch.success"));
    } catch (err: any) {
      error(t("message.fetch.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handleDateFilter = (dates: null | (Dayjs | null)[], dateStrings: string[]) => {
    setDate(dateStrings);
  };
  const handlePagination = (current: number, size: number) => {
    console.log(current);
    setPage({ ...page, page: current, limit: size });
  };

  const goToCreate = () => history.push(PATH_ADD_ADMIN);
  const changeFilter = (value: string) => setFilters(value);
  const searchText = (value: string) => setText(value);
  const handleClearSearch = () => {
    setText("");
    setFilters("");
  };
  const handleClearDate = () => setDate([]);

  const button = (
    <Tooltip title={t("page.add_admin")}>
      {mobile ? (
        <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
      ) : (
        <SharedButton
          type="primary"
          ghost
          icon={<PlusOutlined />}
          size="middle"
          onClick={goToCreate}
        >
          {t("page.add_admin")}
        </SharedButton>
      )}
    </Tooltip>
  );
  return (
    <>
      <ComponentHeader title={t("page.admin_user")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={adminFilter}
            callbackFun={changeFilter}
            onDateChange={handleDateFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            handleClearDate={handleClearDate}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <AdminTable data={data} callback={fetchAdmin} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
